import React from 'react';

let isAdFree = false;
try {
  if (window.getSessionData().subscription.status === 'active') {
    isAdFree = true;
  }
} catch (e) {
  // do nothing
}

const adSlots = {
  'd3planner-left': {
    sizes: [["300", "600"], ["160", "600"]],
  },
  'd3planner-right': {
    sizes: [["300", "600"], ["160", "600"]],
  },
  'd3planner-tab-guide': {
    sizes: [["300", "250"], ["320", "50"], ["320", "100"]],
  },
  'd3planner-tab-equipment': {
    sizes: [["300", "250"], ["320", "50"], ["320", "100"]],
  },
  'd3planner-tab-paragon': {
    sizes: [["320", "50"], ["320", "100"]],
  },
  'd3planner-tab-skills-1': {
    sizes: [["320", "50"], ["320", "100"]],
  },
  'd3planner-tab-skills-2': {
    sizes: [["320", "50"], ["320", "100"]],
  },
  'd3planner-tab-import': {
    sizes: [["300", "250"], ["320", "50"], ["320", "100"]],
  },
};

export default React.memo(function AdUnit({ id, ...props }) {
  React.useEffect(() => {
    if (isAdFree) return;
    window.nitroAds?.createAd(id, {
      refreshLimit: 10,
      refreshTime: 90,
      renderVisibleOnly: true,
      refreshVisibleOnly: true,
      report: {enabled: false},
      sizes: adSlots[id].sizes,
    });
  }, [id]);
  return <div id={id} {...props}/>;
});
